import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import {ApiBaseUrl} from '../../constants';
import { AuthContext } from "./../../context/auth";
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/main.css';

import ErrorHandler from '../include/ErrorHandler';

class SocialSignupComponent extends Component{
    static contextType = AuthContext;

    state = {
        firstname: this.props.location.state.firstname,
        lastname: this.props.location.state.lastname,
        email: this.props.location.state.email,
        phone: '',
        value: '',
        agree: false,
        error: false
    }

    closeErrorHandler = () => {
        this.setState({
            error: false,
            message: ''
        })
    }

    handleInputChange = (event) => {
        const {name,value} = event.target;
        this.setState({
            [name] : value
        })
    }

    handlePhoneNumber = (status, value, countryData, number, id) => {
        this.setState({
            phone: number,
            value: value
        })
    }

    handleCheck = () => {
        this.setState({agree: !this.state.agree});
    }

    handleFormSubmit = (event) => {
        event.preventDefault();
        const phone = this.state.phone.trim();
        const phone_number = phone.replace('-','').replace(' ','').replace('-','');
        if(this.state.firstname.trim() === '')
            this.setState({
                error: true,
                message: 'Please enter first name.'
            })
        else if(this.state.lastname.trim() === '')
            this.setState({
                error: true,
                message: 'Please enter last name.'
            })
        else if(this.state.email.trim() === '')
            this.setState({
                error: true,
                message: 'Please enter email.'
            })
        else if (phone_number.trim() === '' || phone === '')
            this.setState({
                error: true,
                message: 'Please enter phone number'
            })
        else if(this.state.agree !== true)
            this.setState({
                error: true,
                message: 'Please agree to the Terms of Service and Privacy Policy.'
            })
        else {
            this.setState({
                error: false,
                message: ''
            })

            const formBody = "phone_number=" + encodeURIComponent(phone_number);
            fetch(ApiBaseUrl + "/consumer/send_otp",
                {
                    method: 'POST',
                    body: formBody,
                    headers:
                        {
                            "Content-Type": "application/x-www-form-urlencoded"
                        }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if (!result.success) {
                            this.setState({
                                error: true,
                                message: result.message
                            });
                        }
                        else {
                            this.props.history.push({ pathname: process.env.PUBLIC_URL+'/social-login-otp', state: { otp: result.data.code, phone_number: phone_number, firstname: this.state.firstname, lastname: this.state.lastname, email: this.state.email, socialid: this.props.location.state.socialid, socialtype: this.props.location.state.socialtype, image: this.props.location.state.image}});
                        }
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.setState({
                            error: true,
                            message: 'Oops, something went wrong.'
                        });
                    }
                )
        }
    }

    render(){
        return(
            !this.context.authenticated ?
                <React.Fragment>
                    <div className="banner-choose-deal flex-center" style={{backgroundImage: "url('"+process.env.PUBLIC_URL+"/image/banner-choose.png')"}}>
                        <h4 className="banner-choose-deal-heading">Sign up</h4>
                    </div>

                    <div className="choose-deals-outer">
                        <div className="container">
                            <div className="col-md-8 col-lg-7 mx-auto">
                                <div className="loginform-box">
                                    <form autoComplete="off" onSubmit={this.handleFormSubmit}>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="text-center">
                                                    <div className="sociallogin-uploadouter">
                                                        <div className="sociallogin-profilepic">
                                                            <img src={this.props.location.state.image} alt="sociallogin-profilepic"/>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-9">
                                                <div className="changepswd-rows">
                                                    <label>First Name</label>
                                                    <div className="eye">
                                                        <input type="text" className="form-control" name="firstname" onChange={this.handleInputChange} value={this.state.firstname}/>
                                                    </div>
                                                </div>
                                                <div className="changepswd-rows">
                                                    <label>Last Name</label>
                                                    <div className="eye">
                                                        <input type="text" className="form-control" name="lastname" onChange={this.handleInputChange} value={this.state.lastname}/>
                                                    </div>
                                                </div>
                                                <div className="changepswd-rows">
                                                    <label>Email Address</label>
                                                    <div className="eye">
                                                        <input type="email" className="form-control" name="email" readOnly value={this.state.email}/>
                                                    </div>
                                                </div>
                                                <div className="changepswd-rows">
                                                    <label>Phone</label>
                                                    <div className="eye">
                                                    <IntlTelInput
                                                        fieldName="phone"
                                                        inputClassName="form-control w-100"
                                                        defaultValue={this.state.phone}
                                                        onPhoneNumberChange={this.handlePhoneNumber}
                                                        separateDialCode="true"
                                                        placeholder="Enter your phone number"
                                                        preferredCountries={['us']}
                                                        onlyCountries={['us', 'gb', 'au']}
                                                    />
                                                    </div>
                                                </div>

                                                <label className="contain">
                                                    <input type="checkbox" name="checlist-box1" onClick={this.handleCheck} defaultChecked={this.state.agree}/>
                                                    <span className="checkmark"></span>
                                                    By signing up, I agree to the <a href="/terms-of-use" rel="noopener noreferrer" className="text-note" target="_blank">Terms of Service</a> and <a href="/privacy-policy" rel="noopener noreferrer" className="text-note" target="_blank">Privacy Policy</a>
                                                </label>
                                                <div className="btn-rowstack">
                                                    <button className="entry-btn cancel-btn grad-on" type="submit">Next</button>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.error && <ErrorHandler closeHandler={this.closeErrorHandler} message={this.state.message}/>}
                </React.Fragment> :
                <Redirect to={{ pathname: process.env.PUBLIC_URL+'/', state: { from: this.props.location } }} />
        )
    }
}

export default SocialSignupComponent;